import React from "react";
import "../styles/Services.css";

const services = [
  { icon: "fas fa-user-graduate", title: "Mentor" },
  { icon: "fas fa-briefcase", title: "Professional Career guide" },
  { icon: "fas fa-users", title: "Personality Development Trainer" },
  { icon: "fas fa-comments", title: "Life Coach/ Personal Counselor" },
  { icon: "fas fa-handshake", title: "Trainer for Successful Job Interview" },
  {
    icon: "fas fa-chalkboard-teacher",
    title: "Trainer for Students, Parents, Teachers",
  },
  { icon: "fas fa-building", title: "Business Consultant" },
  { icon: "fas fa-microphone", title: "Motivational Speaker" },
  { icon: "fas fa-book", title: "Author" },
];

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <h2>Services Offered</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <i className={service.icon}></i>
              <h3>{service.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
